import axios from 'axios';

const api = axios.create({
    baseURL: '/admin/next-todo/'
});

const adminApi = axios.create({
    baseURL: '/admin/'
});

export const getUserInformation = () => api.get('todo-boards/get-user-info');
export const todoItems = (date, payload) => api.get(`todo-boards${date ? `/${date}` : ''}`, { params: payload });
export const getFollowUpLogs = (id) => api.get(`todo-boards/follow-up-logs/${id}`);
export const saveFollowUpSchedule = (payload) => api.post('todo-boards/follow-up', payload);
export const getCountries = () => api.get('todo-boards/get-countries');
export const getSchools = () => api.get('todo-boards/get-schools');
export const convertLeadToProspect = (payload) => api.post('todo-boards/convert-to-prospect', payload);
export const getLostReasons = () => api.get('todo-boards/get-reasons');
export const sendBoardToLost = (payload) => api.post('todo-boards/send-board-to-lost', payload);
export const markAsDone = (payload) => api.post('todo-boards/mark-as-done', payload);
export const markAsSeen = (id) => api.post(`todo-boards/mark-as-seen/${id}`);
export const getConsultants = (user_id) => api.get(`todo-boards/my-consultants/${user_id}`);
export const approvalFollowUpRequest = (payload) => api.post('todo-boards/board-follow-up/decision', payload);
export const approvalSendToLostRequest = (payload) => api.post('todo-boards/send-board-to-lost/decision', payload);
export const cancelSendToLost = (id) => api.post(`todo-boards/cancel-board-to-lost/${id}`);
export const deleteLabel = (label_id) => api.delete(`todo-boards/delete-user-label/${label_id}`);
export const getCardLabels = (user_id) => api.get(`todo-boards/user-labels/${user_id}`);
export const attachCardlabel = (payload) => api.put('todo-boards/attach-label-to-board', payload);
export const createUserlabel = (payload) => api.post('todo-boards/create-user-label', payload);
export const updateUserlabel = (label_id, payload) => api.put(`todo-boards/update-user-label/${label_id}`, payload);
export const saveColumnOrder = (payload) => api.post('todo-boards/update-column-order', payload);
export const getFollowUpTypes = (board_id) => api.get(`todo-boards/${board_id}/follow-up/types`);
export const getJourneysItems = (date, payload) => api.get(`todo-boards/journey-list${date ? `/${date}` : ''}`, { params: payload });
export const saveContactedStatus = (id, payload) => api.post(`todo-boards/contacted/${id}`, payload);
export const saveAssignedConsultant = (id, type, payload) => adminApi.post(`${type}/${id}/transfer-consultant`, payload);